import { FC, useContext, useEffect } from "react";
import { TeamContext } from "../context";
import { useHistory } from "react-router-dom";

const SummaryRoute: FC<{}> = () => {
    const { urlToken, gameId } = useContext(TeamContext);
    
    let history = useHistory();

    useEffect(() => {
        history.push( "/survey/" + urlToken + "/" + gameId); 
    }, [gameId, history, urlToken]);
    
    return (
        <div>
        </div>
    );
}

export default SummaryRoute;